import React, { useEffect, useState } from "react";
import { Link } from "@/lib/nav";
import { useTranslation } from "react-i18next";
import { Cookie } from "lucide-react";

const KEY = "lattice_cookie_consent_v1";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);

  const decide = (choice) => {
    localStorage.setItem(KEY, choice);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="pointer-events-none fixed bottom-[4.75rem] left-4 right-4 z-[70] lg:bottom-4 sm:right-auto sm:max-w-sm" data-testid="cookie-banner">
      <div className="pointer-events-auto border border-[#262626] bg-[#0b0b0b]/95 p-4 backdrop-blur-xl lt-glow-primary">
        <div className="flex items-center gap-2 lp-c">
          <Cookie className="h-5 w-5 shrink-0" />
          <span className="font-mono text-[11px] uppercase tracking-widest">{t("cookieBanner.label")}</span>
        </div>
        <p className="mt-3 text-[13px] leading-relaxed text-[#a3a3a3]">
          {t("cookieBanner.textPre")}
          <Link to="/cookie" className="text-white underline lp-h-c">Cookie Policy</Link>{t("cookieBanner.and")}
          <Link to="/privacy" className="text-white underline lp-h-c">Privacy</Link>{t("cookieBanner.textEnd")}
        </p>
        <div className="mt-4 flex gap-2">
          <button
            onClick={() => decide("rejected")}
            data-testid="cookie-reject"
            className="flex-1 border border-white/15 px-3 py-2 font-mono text-[11px] uppercase tracking-wider text-[#a3a3a3] transition-colors hover:text-white"
          >
            {t("cookieBanner.essential")}
          </button>
          <button
            onClick={() => decide("accepted")}
            data-testid="cookie-accept"
            className="flex-1 border lp-bd lp-b px-3 py-2 font-mono text-[11px] uppercase tracking-wider text-white transition-colors hover:bg-[#3fa862]"
          >
            {t("cookieBanner.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
